import styled from 'styled-components';

export const MachinesInTheLineWidgetContainer = styled.div`
  .header-btn-container {
    margin-bottom: 1rem;
    .widget-ui__header {
      border: none;
      padding-left: 0px !important;
      padding-right: 0px !important;
      .tooltip-wrapper {
        padding: 4px;
        border-radius: 4px;
        border: 0.5px solid var(--Brand-color-Blue, #0076CC);
        background: var(--Gray-Scale-200, #F2F3F4);
        box-shadow: 0 0 4px 0 rgba(0, 118, 204, 0.24) inset, 0 0 4px 0 rgba(0, 118, 204, 0.19);
      }
    }
  }

  .machines-container {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    margin: 0 auto;

    .widget-ui__main {
      overflow-y: intial;
    }

    .widget-ui {
      border-radius: 20px;
      border-color: transparent;
      background: #FFF;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.12);
      max-width: 400px;
      width: 100%;
      overflow: hidden;
      flex-grow: 1;
      flex-basis: 300px;
    }
  }
`;
